import { Filter, TextInput } from 'react-admin';

export const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
  </Filter>
);
